<template>
    <div class="report-container">
        <!-- ສ່ວນຫົວຂອງໜ້າ -->
        <div class="page-header no-print">
            <div class="breadcrumb">ໜ້າຫຼັກ / ລາຍງານ / <span>ສະຖິຕິໂຮງຮຽນ</span></div>
            <div class="header-content-wrapper">
                <div>
                    <h1>ບົດລາຍງານສະຖິຕິພາຍໃນໂຮງຮຽນ</h1>
                    <p>ສະຫຼຸບຂໍ້ມູນນັກຮຽນ ແລະ ບຸກຄະລາກອນ ປະຈຳສົກຮຽນ</p>
                </div>
                <div class="header-actions">
                    <button class="btn-print" @click="printReport">
                        <i class="fas fa-print"></i> ພິມລາຍງານ
                    </button>
                </div>
            </div>
        </div>

        <!-- ສ່ວນ Filter ກັ່ນຕອງຂໍ້ມູນ -->
        <div class="panel filter-panel no-print mb-4">
            <div class="panel-body">
                <div class="filter-grid">
                    <div class="form-group">
                        <label>ສົກຮຽນ</label>
                        <select v-model="filters.academicYear" @change="fetchReportData">
                            <option v-for="year in academicYears" :key="year" :value="year">
                                {{ year }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>ພາກຮຽນ</label>
                        <select v-model="filters.semester" @change="fetchReportData">
                            <option value="1">ພາກຮຽນ I</option>
                            <option value="2">ພາກຮຽນ II</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <!-- ສ່ວນເນື້ອໃນລາຍງານ (ທີ່ຈະສະແດງທັງໃນໜ້າຈໍ ແລະ ເວລາພິມ) -->
        <div class="report-content-paper">
            <div class="report-header-print only-print">
                <h2>ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ</h2>
                <h3>ສັນຕິພາບ ເອກະລາດ ປະຊາທິປະໄຕ ເອກະພາບ ວັດທະນາຖາວອນ</h3>
                <div class="report-title-section">
                    <h4>ບົດລາຍງານສະຖິຕິການສຶກສາ</h4>
                    <p>ໂຮງຮຽນ: {{ user.school_name }} | ສົກຮຽນ: {{ filters.academicYear }}</p>
                </div>
            </div>

            <!-- KPI Summary Cards -->
            <div class="kpi-grid mb-4">
                <div class="kpi-card border">
                    <div class="kpi-label">ນັກຮຽນທັງໝົດ</div>
                    <div class="kpi-value text-primary">{{ reportData.summary.totalStudents }}</div>
                    <div class="kpi-sub">ຍິງ: {{ reportData.summary.femaleStudents }} | ຊາຍ: {{ reportData.summary.maleStudents }}</div>
                </div>
                <div class="kpi-card border">
                    <div class="kpi-label">ຄູ-ພະນັກງານ</div>
                    <div class="kpi-value text-success">{{ reportData.summary.totalStaff }}</div>
                    <div class="kpi-sub">ຍິງ: {{ reportData.summary.femaleStaff }}</div>
                </div>
                <div class="kpi-card border">
                    <div class="kpi-label">ຫ້ອງຮຽນທັງໝົດ</div>
                    <div class="kpi-value text-warning">{{ reportData.summary.totalClasses }}</div>
                    <div class="kpi-sub">ຫ້ອງ</div>
                </div>
            </div>

            <!-- ຕາຕະລາງແຍກຕາມຊັ້ນຮຽນ -->
            <div class="panel mb-4">
                <div class="panel-head">
                    <h3><i class="fas fa-table mr-2"></i> ສະຖິຕິນັກຮຽນແຍກຕາມຊັ້ນຮຽນ</h3>
                </div>
                <div class="panel-body">
                    <table class="report-table">
                        <thead>
                            <tr>
                                <th>ຊັ້ນຮຽນ</th>
                                <th>ຈຳນວນຫ້ອງ</th>
                                <th>ຍິງ</th>
                                <th>ຊາຍ</th>
                                <th class="bg-light">ລວມ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in reportData.gradeStats" :key="item.grade">
                                <td>{{ item.grade }}</td>
                                <td>{{ item.classes }}</td>
                                <td>{{ item.female }}</td>
                                <td>{{ item.male }}</td>
                                <td class="font-weight-bold">{{ item.female + item.male }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="table-total">
                                <td>ລວມທັງໝົດ</td>
                                <td>{{ reportData.summary.totalClasses }}</td>
                                <td>{{ reportData.summary.femaleStudents }}</td>
                                <td>{{ reportData.summary.maleStudents }}</td>
                                <td>{{ reportData.summary.totalStudents }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/utils/api';

export default {
    name: 'SchoolReportPage',
    data() {
        return {
            loading: false,
            user: JSON.parse(localStorage.getItem('user-info') || '{}'),
            academicYears: [],
            filters: {
                academicYear: '',
                semester: '1'
            },
            reportData: {
                summary: {
                    totalStudents: 0,
                    femaleStudents: 0,
                    maleStudents: 0,
                    totalStaff: 0,
                    femaleStaff: 0,
                    totalClasses: 0
                },
                gradeStats: []
            }
        };
    },
    mounted() {
        this.generateAcademicYears();
        this.fetchReportData();
    },
    methods: {
        generateAcademicYears() {
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth(); // 0 = Jan, 6 = July
            
            // ປົກກະຕິສົກຮຽນໃໝ່ຈະເລີ່ມປະມານເດືອນ 7 ຫຼື 8
            // ຖ້າເດືອນປັດຈຸບັນ >= ກໍລະກົດ ໃຫ້ເລີ່ມທີ່ປີນີ້, ຖ້າບໍ່ແມ່ນໃຫ້ເລີ່ມທີ່ປີຜ່ານມາ
            let startYear = currentMonth >= 6 ? currentYear : currentYear - 1;
            
            const years = [];
            for (let i = 0; i < 10; i++) {
                const y = startYear - i;
                years.push(`${y}-${y + 1}`);
            }
            this.academicYears = years;
            this.filters.academicYear = years[0];
        },
        async fetchReportData() {
            this.loading = true;
            try {
                // ສົມມຸດເອົາ API ທີ່ໃຊ້ດຶງຂໍ້ມູນລາຍງານ
                const res = await api.get('/reports/school-summary', {
                    params: { 
                        school_id: this.user.school_id,
                        year: this.filters.academicYear
                    }
                });
                if (res.data.code === 1) {
                    this.reportData = res.data.data;
                }
            } catch (e) {
                console.error('Fetch Report Error:', e);
                // ເພີ່ມຂໍ້ມູນຈຳລອງເພື່ອທົດສອບ UI
                this.mockData();
            } finally {
                this.loading = false;
            }
        },
        mockData() {
            this.reportData = {
                summary: { totalStudents: 450, femaleStudents: 230, maleStudents: 220, totalStaff: 35, femaleStaff: 20, totalClasses: 12 },
                gradeStats: [
                    { grade: 'ມ1', classes: 3, female: 60, male: 55 },
                    { grade: 'ມ2', classes: 3, female: 58, male: 52 },
                    { grade: 'ມ3', classes: 3, female: 55, male: 60 },
                    { grade: 'ມ4', classes: 3, female: 57, male: 53 }
                ]
            };
        },
        printReport() {
            window.print();
        }
    }
};
</script>

<style scoped>
.report-container { padding: 20px; animation: fadeIn 0.4s ease; }
.header-content-wrapper { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 20px; }
.btn-print { background: var(--lao); color: white; border: none; padding: 10px 20px; border-radius: 8px; cursor: pointer; font-weight: 600; }
.filter-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 20px; }

.report-table { width: 100%; border-collapse: collapse; margin-top: 10px; }
.report-table th, .report-table td { border: 1px solid #e2e8f0; padding: 12px; text-align: center; }
.report-table th { background: #f8fafc; color: #475569; font-weight: 700; }
.table-total { background: #f1f5f9; font-weight: 800; }

.report-header-print { text-align: center; margin-bottom: 30px; }
.report-title-section { margin-top: 20px; border-top: 2px solid #000; padding-top: 10px; }

.only-print { display: none; }

@media print {
    .no-print { display: none !important; }
    .only-print { display: block !important; }
    .report-container { padding: 0; }
    .panel { border: none !important; box-shadow: none !important; }
    .kpi-card { border: 1px solid #000 !important; }
    body { background: white; }
    .report-table th { background: #eee !important; -webkit-print-color-adjust: exact; }
}

@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>